import DatasetList from "./DatasetList";
import StatementList from "./StatementList";
import DatasetCreate from "./DatasetCreate";
import DatasetUpdate from "./DatasetUpdate";
import StatementStatistics from "./StatementStatistics";

const routes = [
    {
        path: "company/:company/datasets/list",
        component: () => <DatasetList />,
        isSidebar: true,
        isPublic: false,
        permissions: ["view_datasets"],
    },
    {
        path: "company/:company/datasets/:name",
        component: () => <StatementList />,
        isSidebar: true,
        isPublic: false,
        permissions: ["update_dataset"],
    },
    {
        path: "company/:company/dataset/create",
        component: () => <DatasetCreate />,
        isSidebar: true,
        isPublic: false,
        permissions: ["create_dataset"],
    },
    {
        path: "company/:company/dataset/update",
        component: (data) => <DatasetUpdate data={data} />,
        isSidebar: true,
        isPublic: false,
        permissions: ["update_dataset"],
    },
    {
        path: "company/:company/datasets/:name/statistics",
        component: () => <StatementStatistics />,
        isSidebar: true,
        isPublic: false,
        permissions: ["update_dataset"],
    },
];

export default routes;
